import {useSelector} from 'react-redux'
import {useRouter} from 'next/router'
import {
  getLandingTrafficSourceFromUrl,
  getSrpSearchFlow
} from 'utils/trafficSource'

import {useBrand} from '@vio/core/src/_web/brand/hooks/useBrand'

/**
 * Determines if the user arrived at the AP from a SEO SRP flow.
 * Restricted to the Vio brand to avoid affecting white label partner flows,
 * which don't have SEO SRP pages.
 */
export const useIsSrpSearchSeoFlow = (): boolean => {
  const {query} = useRouter()
  const {brand} = useBrand()
  const trafficSource = useSelector(getLandingTrafficSourceFromUrl)
  const srpSearchFlowParam =
    typeof query.srpSearchFlow === 'string' ? query.srpSearchFlow : undefined

  return getSrpSearchFlow(brand, trafficSource, srpSearchFlowParam) === 'seo'
}
